import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["id", "icon", "label", "checked", "onChangeHandler", "testId"],
    _excluded2 = ["options", "onChangeHandler", "value", "customChipGroupStyles", "testId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useMemo, memo, forwardRef } from 'react';
import { filterIconMap } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChipCheckBox = /*#__PURE__*/memo(function (props) {
  var id = props.id,
      icon = props.icon,
      label = props.label,
      checked = props.checked,
      onChangeHandler = props.onChangeHandler,
      testId = props.testId,
      rest = _objectWithoutProperties(props, _excluded);

  var Icon = filterIconMap[icon];
  var iconEl = useMemo(function () {
    return Icon ? typeof Icon === 'string' ? /*#__PURE__*/_jsx(IconSrc, {
      src: Icon,
      alt: label
    }) : /*#__PURE__*/_jsxs(IconWrapper, {
      isActive: checked,
      children: [/*#__PURE__*/_jsx(Icon, {
        size: 24,
        stroke: checked ? "#ffffff" : "#1C1327"
      }), ' ']
    }) : null;
  }, [Icon, checked, label]);
  var inputEl = useMemo(function () {
    return /*#__PURE__*/_jsx(CheckboxInput, _objectSpread({
      id: id,
      type: "checkbox",
      checked: checked,
      onChange: function onChange(e) {
        e.stopPropagation();
        if (onChangeHandler) onChangeHandler(id);
      }
    }, rest));
  }, [checked, id, onChangeHandler, rest]);
  return /*#__PURE__*/_jsxs(StyledChipCheckbox, {
    "data-cy": testId,
    checked: checked,
    children: [iconEl, inputEl, /*#__PURE__*/_jsx(_StyledSpan, {
      children: label
    })]
  }, id);
});
export var ChipCheckboxGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var options = _ref.options,
      onChangeHandler = _ref.onChangeHandler,
      value = _ref.value,
      customChipGroupStyles = _ref.customChipGroupStyles,
      testId = _ref.testId,
      rest = _objectWithoutProperties(_ref, _excluded2);

  return /*#__PURE__*/_jsx(ChipGroupStyled, {
    "data-cy": testId,
    $customStyles: customChipGroupStyles,
    ref: ref,
    children: options === null || options === void 0 ? void 0 : options.map(function (chip, index) {
      return /*#__PURE__*/_jsx(ChipCheckBox, _objectSpread(_objectSpread(_objectSpread({
        testId: "".concat(chip.key)
      }, rest), _objectSpread(_objectSpread({}, chip), {}, {
        onChangeHandler: onChangeHandler
      })), {}, {
        checked: Array.isArray(value) ? (value === null || value === void 0 ? void 0 : value.indexOf(chip.id)) > -1 : value === chip.id
      }), index.toString());
    })
  });
});

var StyledChipCheckbox = /*#__PURE__*/_styled.label.withConfig({
  displayName: "checkboxchip__StyledChipCheckbox",
  componentId: "sc-5seh9b-0"
})(["", " ", ""], {
  "marginRight": "0.5rem",
  "display": "inline-flex",
  "cursor": "pointer",
  "alignItems": "center",
  "gap": "0.5rem",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(156 163 175 / var(--tw-border-opacity))",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem"
}, function (_ref2) {
  var checked = _ref2.checked;
  return checked ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  };
});

var ChipGroupStyled = /*#__PURE__*/_styled.div.withConfig({
  displayName: "checkboxchip__ChipGroupStyled",
  componentId: "sc-5seh9b-1"
})(function (_ref3) {
  var $customStyles = _ref3.$customStyles;
  return [{
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "gap": "0.5rem"
  }, $customStyles];
});

var CheckboxInput = /*#__PURE__*/_styled.input.withConfig({
  displayName: "checkboxchip__CheckboxInput",
  componentId: "sc-5seh9b-2"
})({
  "display": "none"
});

var IconSrc = /*#__PURE__*/_styled.img.withConfig({
  displayName: "checkboxchip__IconSrc",
  componentId: "sc-5seh9b-3"
})({
  "marginRight": "0.5rem",
  "height": "1rem",
  "width": "1rem"
});

var IconWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "checkboxchip__IconWrapper",
  componentId: "sc-5seh9b-4"
})(["", " ", ""], {
  "display": "flex",
  "height": "1rem",
  "width": "1rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.5rem"
}, function (_ref4) {
  var isActive = _ref4.isActive;
  return isActive ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))"
  } : {};
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "checkboxchip___StyledSpan",
  componentId: "sc-5seh9b-5"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400"
});